<template>
    <div class="sets-msg-content" :class="[theme]" v-show="visible" transition="msg">
        <slot></slot>
    </div>
</template>

<script lang="babel">
    import _ from 'lodash'
    export default{
        props: {
            theme: {
                type: String,
                default: 'info'
            },
            duration: {
                type: Number,
                default: 2500
            }
        },
        events: {
            show() {
                this.visible = true
                if (this.duration) {
                    _.delay(() => {
                        this.hide()
                    }, this.duration)
                }
            }
        },
        data() {
            return {
                visible: false
            }
        },
        methods: {
            hide() {
                this.visible = false
                this.$dispatch('close')
            }
        }
    }
</script>
<style>
</style>


// WEBPACK FOOTER //
// msg.vue?56ee3056